import React, { useRef } from "react";
import { VisuallyHidden } from "@streeteasy/design-system/style-utilities/visually-hidden";
import { any, arrayOf, func, string } from "prop-types";

import * as S from "./styled";

const SelectedLocations = ({
  filters,
  labelIdentity,
  onFilterClick,
  title
}) => {
  const filterListRef = useRef();
  const handleFilterClick = filter => {
    onFilterClick(filter);
    filterListRef.current.focus();
  };

  return (
    <>
      <S.LocationsLabel>{title}</S.LocationsLabel>
      <S.List ref={filterListRef} tabIndex="-1">
        {filters.map(filter => {
          const label = labelIdentity(filter);

          return (
            <S.ListItem key={label}>
              <S.LocationChip onClick={() => handleFilterClick(filter)}>
                {label}
                <VisuallyHidden> Click to remove {label}</VisuallyHidden>
              </S.LocationChip>
            </S.ListItem>
          );
        })}
      </S.List>
    </>
  );
};

SelectedLocations.propTypes = {
  onFilterClick: func.isRequired,
  filters: arrayOf(any).isRequired,
  labelIdentity: func,
  title: string
};

SelectedLocations.defaultProps = {
  labelIdentity: value => value,
  title: "You Selected"
};

export default SelectedLocations;
